import type { RouteRecordRaw } from 'vue-router';

import { routes as documentRoutes } from '@abaninja/page-customer-portal-documents';

export const routes: RouteRecordRaw[] = [
  {
    name: 'index',
    path: '/',
    redirect: { name: 'documents' },
    component: () => import('../../layout/Default.vue'),
    children: [
      ...documentRoutes,
    ],
    meta: {
      needsAuth: true,
    },
  },
  {
    path: '/',
    children: [
      {
        children: [],
        path: 'portal/:hash',
        // props: true,
        redirect: { name: 'index', params: undefined },
      },
      {
        path: '404',
        component: () => import('../../layout/MainView.vue'),
        children: [
          {
            name: '404',
            path: '',
            component: () => import('../../pages/NotFound.vue'),
          },
        ],
      },
      {
        path: ':pathMatch(.*)*',
        redirect: (to) => ({
          name: '404',
          query: {
            toPath: to.fullPath,
          },
        }),
      },
    ],
  },

];
